
export function formatTimeSpent(timeSpent) {
  if (isNaN(timeSpent)) return '0s';
  const totalSeconds = Math.floor(timeSpent / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const remainingSeconds = totalSeconds % 3600;
  const minutes = Math.floor(remainingSeconds / 60);
  const seconds = remainingSeconds % 60;
  
  if (hours > 0) {
    return `${hours}h ${minutes}m`; // Don't show seconds for hour+ durations
  } else if (minutes > 0) {
    return `${minutes}m ${seconds}s`;
  } else {
    return `${seconds}s`;
  }
}

export class Validate {
    //https://github.com/amrlabib/react-timer-hook/blob/master/src/utils/Validate.js
    static expiryTimestamp(expiryTimestamp) {
        const isValid = (new Date(expiryTimestamp)).getTime() > 0;
        if (!isValid) {
            console.warn('react-timer-hook: { useTimer } Invalid expiryTimestamp settings', expiryTimestamp); // eslint-disable-line
        }
        return isValid;
    }

    static onExpire(onExpire) {
        const isValid = onExpire && typeof onExpire === 'function';
        if (onExpire && !isValid) {
            console.warn('react-timer-hook: { useTimer } Invalid onExpire settings function', onExpire); // eslint-disable-line
        }
        return isValid;
    }
}
export class Time {
    // https://github.com/amrlabib/react-timer-hook/blob/master/src/utils/Time.js
    static getTimeFromSeconds(totalSeconds) {
        const days = Math.floor(totalSeconds / (60 * 60 * 24));
        const hours = Math.floor((totalSeconds % (60 * 60 * 24)) / (60 * 60));
        const minutes = Math.floor((totalSeconds % (60 * 60)) / 60);
        const seconds = Math.floor(totalSeconds % 60);

        return {
            seconds,
            minutes,
            hours,
            days,
        };
    }

    static getSecondsFromExpiry(expiry) {
        const now = new Date().getTime();
        const milliSecondsDistance = expiry - now;
        if (milliSecondsDistance > 0) {
            return Math.floor(milliSecondsDistance / 1000);
        }
        return 0;
    }

    static getSecondsFromTimeNow() {
        const now = new Date();
        const currentTimestamp = now.getTime();
        const offset = (now.getTimezoneOffset() * 60);
        return (currentTimestamp / 1000) - offset;
    }

    static getFormattedTimeFromSeconds(totalSeconds, format) {
        const { seconds: secondsValue, minutes, hours } = Time.getTimeFromSeconds(totalSeconds);
        let ampm = '';
        let hoursValue = hours;

        if (format === '12-hour') {
            ampm = hours >= 12 ? 'pm' : 'am';
            hoursValue = hours % 12;
        }

        return {
            seconds: secondsValue,
            minutes,
            hours: hoursValue,
            ampm,
        };
    }
}

